import { ShapeProps } from './types';

const Polygon = ({ fill, size }: ShapeProps) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 193 190"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M128.356 0.438342L0.641131 109.677L108.581 189.126L192.187 169.025L128.356 0.438342Z"
				fill={fill}
			/>
		</svg>
	);
};

export default Polygon;
